import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { ISchoolDTOIn } from './../interfaces/groups/school.interface';
import { mockSchools } from './schools.mock';

export const mockSchoolsRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.SCHOOLS)) {
        const response: any = {
            status: 200,
            body: { schools: mockSchools },
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'GET' && request.url.includes(SubUrlsEnum.SCHOOL)) {
        const response: any = {
            status: 200,
            body: mockSchools.find(
                (school: ISchoolDTOIn) => school.id === +request.url.replace(environment.wasoApi + SubUrlsEnum.SCHOOL, '')
            ),
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
